<template>
  <div>
    <!-- 顶部横向tabs切换栏目 -->
    <div class="tabsContent">
      <!-- 文字 -->
      <div class="tabs_title">
        <!-- class="title_item" -->
        <div v-for="(item, index) in tabs" :key="item.id" :class="['title_item', item.isActive ? 'active' : '']" @click="handleItemTap(index), $emit('tab-click', item)">
          {{ item.value }}
          <span class="badge" v-if="item.quantity">{{ item.quantity }}</span>
        </div>
        <!-- 插槽 -->

        <div>
          <slot name="button"></slot>
        </div>
      </div>
      <!-- tabs下方内容区域 -->
      <div class="tabs_content">
        <slot></slot>
      </div>
      <jr-pagination
        v-if="showPagination"
        :limit="pageOptions.limit"
        :page.sync="pageOptions.page"
        :total="pageOptions.total"
        :hidden="pageHide"
        :pageSizes="pageOptions.pageSizes"
        @change="paginationChange"
      >
      </jr-pagination>
    </div>
  </div>
</template>
<script>
import JrPagination from '@/components/Pagination'
export default {
  name: 'Tabs',
  components: {
    JrPagination
  },
  props: {
    // 横向tabs切换栏目源数据
    tabs: {
      required: true,
      default: () => []
    },
    pageHide: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * 分页参数
     * limit:每页显示的条数
     * page:当前页码
     * total:总条数
     * pageSizes: 显示多少条集合
     * hidden: 是否显示分页
     */
    pageOptions: {
      type: Object,
      default() {
        return {
          limit: 10,
          page: 1,
          total: 0,
          pageSizes: [10, 20, 30, 50],
          hidden: false
        }
      }
    },
    /* 是否显示分页栏 */
    showPagination: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pagination: {
        limit: 10,
        page: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
        hidden: false
      }
    }
  },
  created() {
    // 扩展配置，目的是引用组件不用把配置全写一遍
    this.pagination = Object.assign({}, this.pagination, this.pageOptions)
  },
  methods: {
    // 发生点击事件时触发
    handleItemTap(index) {
      // 1 拿到item中叫做 index 的数据，获取点击的tab的索引
      // console.log(index)
      // 2 修改顶部横向tabs切换栏目 源数组
      //  复制出一份数据用来修改
      const tabsList = this.tabs
      // *通过循环，将当前传过来的index的tabs的isActive设置为true，其他栏目则设置为false 那就有选中的样式了
      // !之所以要用  [{},{}..]  这种格式，是因为forEach本身不会改变原数组，但是如果 修改【对象数组】，就能改变 原数据 了
      // 不过这里用的是复制出来的tabsList，不是data中的数据(为了保险) 所以还是要  this.tabs = tabsList 重新赋值一遍的
      tabsList.forEach((v, i) => (i === index ? (v.isActive = true) : (v.isActive = false)))
      //   console.log(tabsList,'tab');
      // 3 赋值修改过后的数据到data中本来的tabs数据源
      this.tabs = tabsList
    },
    paginationChange(pager) {
      const { page, limit } = pager
      this.$emit('page-change', { page, limit })
    }
  }
}
</script>

<style lang="scss" scoped>
// 整个tabs切换栏目，包含内容在内
.tabsContent {
  width: 100%;
  background: #ffffff;
}
/* 横向文字title*/
.tabs_title {
  display: flex;
  align-items: center;
  // 阴影
  color: #333333;
  font-weight: 400;
  font-size: 15px;
  line-height: 36px;
  // width: 40%;
}
/* 每个文字居中，且占1份 */
.title_item {
  display: flex;
  justify-content: center;
  height: 45px;
  line-height: 45px;
  border: 1px solid rgb(235, 242, 253);
  margin-right: 20px;
  cursor: pointer;
  position: relative;
  width: 120px;
  padding: 0 8px;
  background: #fafafa;
  .badge {
    position: absolute;
    top: -20%;
    left: 90%;
    width: 30px;
    height: 19px;
    background: #fb4a40;
    color: #fff;
    border-radius: 10px;
    text-align: center;
    line-height: 19px;
    padding: 1px;
  }
}
/* 选中样式 */
.active {
  color: #fff;
  background: linear-gradient(to bottom, #006cfa, #4a99fd);
  border: none;
}
.tabs_content {
  min-height: 200px;
  max-height: 660px;
  overflow: auto;
  background: #fafafa;
  border: 1px solid rgb(245, 248, 254);
}
</style>
